import { useCpf } from "@/contexts/cpfContext";
import { Box, Heading } from "@chakra-ui/react";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useProposalStore } from "@/contexts/useProposalStore";
import { useConditionalBackground } from "@/contexts/useConditionalBackground ";

export default function ShowProposal() {
  const { cpf } = useCpf();
  const { shorthash } = useParams<{ shorthash: string }>();
  const { proposal } = useProposalStore();
  const backgroundStyle = useConditionalBackground();


  const navigate = useNavigate();

  useEffect(() => {
    if (cpf.length === 0 || proposal?.id?.length === 0) {
      navigate(`/${shorthash}/introducao`);
    }
  }, []);



  return (
    <Box
      minWidth="100vw"
      minHeight="100vh"
      {...backgroundStyle}
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      justifyContent="space-between"
      px={8}
      py={16}
    > 
    <Heading>Proposta</Heading>
      
    </Box>
  );
}
